import { queryOptions, skipToken } from '@tanstack/react-query';

import { IndividualReport, Optional } from 'chaika-frontend-types/frontend-cms';
import { FileEntityType, IndividualReportType } from 'chaika-enums';

import { FileApi, IndividualReportsApi } from '@api';

const STALE_TIME_MS = 5 * 60 * 1000;

export const individualReportKeys = {
    all: ['individualReports'] as const,
    active: (legalEntityId: string, type: IndividualReportType) =>
        [...individualReportKeys.all, 'active', legalEntityId, type] as const,
};

export const individualReportQueryOptions = {
    /**
     * Отчёты юрлица выбранного типа, к которым приложен файл: без файла отчёт напечатать нечем,
     * поэтому неактивные сюда не попадают.
     */
    active: (legalEntityId: Optional<string>, type: IndividualReportType) =>
        queryOptions({
            queryKey: individualReportKeys.active(legalEntityId ?? '', type),
            queryFn: legalEntityId ? () => findActiveReports(legalEntityId, type) : skipToken,
            staleTime: STALE_TIME_MS,
        }),
};

async function findActiveReports(legalEntityId: string, type: IndividualReportType): Promise<IndividualReport[]> {
    const reports = (await IndividualReportsApi.getReports(legalEntityId)).filter(report => report.type === type);

    if (reports.length === 0) {
        return [];
    }

    const files = await FileApi.getFiles(
        reports.map(report => report.id),
        FileEntityType.LegalEntityIndividualReport,
    );
    const reportIdsWithFiles = new Set(files.map(file => file.entityId));

    return reports.filter(report => reportIdsWithFiles.has(report.id));
}
